import React from 'react';
import { Target, Handshake, Landmark, TrendingUp } from 'lucide-react';
import { formatCurrency, formatPercent } from '../../../utils/formatters';
import { Card } from '../../../components/ui/Card';

function MetricCard({ label, value, helper, icon: Icon }) {
  return (
    <Card className="p-4 shadow-hp-sm">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-subtle">
            {label}
          </p>
          <p className="mt-2 text-2xl font-semibold tabular-nums tracking-tight text-primary">
            {value}
          </p>
          {helper && (
            <p className="mt-1 text-xs text-subtle">
              {helper}
            </p>
          )}
        </div>
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-surface-muted text-primary">
          <Icon className="h-4.5 w-4.5" />
        </div>
      </div>
    </Card>
  );
}

export default function TransactionMetrics({ transaction }) {
  if (!transaction) return null;

  const investors = transaction.participants?.filter(p => p.role === 'Investisseur' || p.role === 'Prêteur') || [];
  const totalEngaged = investors.reduce((sum, p) => sum + (p.committedAmount || 0), 0);
  const totalCalled = investors.reduce((sum, p) => sum + (p.calledAmount || 0), 0);

  const engagementRate = Math.round((totalEngaged / (transaction.targetAmount || 1)) * 100) || 0;
  const callRate = Math.round((totalCalled / (totalEngaged || 1)) * 100) || 0;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <MetricCard
        label="Objectif"
        value={formatCurrency(transaction.targetAmount, transaction.currency)}
        helper="Montant total recherché"
        icon={Target}
      />

      <MetricCard
        label="Engagé"
        value={formatCurrency(totalEngaged, transaction.currency)}
        helper={`${engagementRate}% de l'objectif`}
        icon={Handshake}
      />

      <MetricCard
        label="Appelé"
        value={formatCurrency(totalCalled, transaction.currency)}
        helper={`${callRate}% des engagements`}
        icon={Landmark}
      />

      <MetricCard
        label="Rendement cible"
        value={formatPercent(transaction.yieldRate)}
        helper={
          transaction.durationMonths
            ? `Horizon ${transaction.durationMonths} mois`
            : "Durée non renseignée"
        }
        icon={TrendingUp}
      />
    </div>
  );
}
